module.exports = __webpack_public_path__ + "static/media/sigrid.14350a8c.jpg";